if (!customElements.get('tr-pagination')) {
	class TrPagination extends HTMLElement {
		selectors = {
			button: '[data-tr-js-pagination-button]',
			items: '[data-tr-js-pagination-items]',
			section: '[data-tr-js-pagination-section]',
		};

		attributes = {
			nextUrl: 'data-tr-pagination-next-url',
		};

		stateClasses = {
			isLoading: 'is-loading',
			isDisabled: 'is-disabled',
		};

		connectedCallback() {
			this.buttonElement = this.querySelector(this.selectors.button);
			this.sectionElement = this.closest(this.selectors.section);
			this.itemsElement = this.sectionElement?.querySelector(
				this.selectors.items
			);
			this.init();
			this.bindEvents();
			document.addEventListener('shopify:section:load', this.onSectionLoad);
			document.addEventListener('shopify:block:select', this.onBlockSelect);
		}

		disconnectedCallback() {
			document.removeEventListener('shopify:section:load', this.onSectionLoad);
			document.removeEventListener('shopify:block:select', this.onBlockSelect);
			this.destroy();
		}

		init() {
			this.nextUrl = this.getAttribute(this.attributes.nextUrl);
			this.isLoading = false;
		}

		bindEvents() {
			this.buttonElement?.removeEventListener('click', this.onButtonClick);
			this.buttonElement?.addEventListener('click', this.onButtonClick);
		}

		onButtonClick = (event) => {
			event.preventDefault();
			this.loadArticles();
		};

		onSectionLoad = (event) => {
			const sectionId = event.detail.sectionId;

			if (
				!this.closest(`#shopify-section-${sectionId}`) &&
				!this.closest(`#${sectionId}`)
			) {
				return;
			}

			this.destroy();
			this.init();
			this.bindEvents();
		};

		onBlockSelect = (event) => {
			if (this.dataset.blockId !== event.detail.blockId) return;
		};

		async loadArticles() {
			if (this.isLoading || !this.nextUrl || !this.itemsElement) return;

			this.setLoadingState(true);
			await this.waitForNextFrame();

			try {
				const response = await fetch(this.nextUrl);
				const text = await response.text();
				const nextDocument = new DOMParser().parseFromString(
					text,
					'text/html'
				);

				this.appendItems(nextDocument);
				this.updateNextUrl(nextDocument);
			} catch (error) {
				window.location.assign(this.nextUrl);
			} finally {
				this.setLoadingState(false);
			}
		}

		appendItems(nextDocument) {
			const nextItems = nextDocument.querySelectorAll(
				`${this.selectors.items} > *`
			);

			nextItems.forEach((itemElement) => {
				this.itemsElement.append(itemElement);
			});
		}

		updateNextUrl(nextDocument) {
			const nextPaginationElement = nextDocument.querySelector(
				this.selectors.button
			);
			const nextUrl = nextPaginationElement?.getAttribute('href');

			if (nextUrl) {
				this.nextUrl = nextUrl;
				this.setAttribute(this.attributes.nextUrl, nextUrl);
				this.buttonElement.setAttribute('href', nextUrl);

				return;
			}

			this.remove();
		}

		setLoadingState(isLoading) {
			this.isLoading = isLoading;
			this.classList.toggle(this.stateClasses.isLoading, isLoading);
			this.buttonElement?.classList.toggle(
				this.stateClasses.isDisabled,
				isLoading
			);
			this.buttonElement?.classList.toggle(
				this.stateClasses.isLoading,
				isLoading
			);
			this.buttonElement?.setAttribute('aria-busy', String(isLoading));
			this.buttonElement?.setAttribute('aria-disabled', String(isLoading));
		}

		waitForNextFrame() {
			return new Promise((resolve) => {
				window.requestAnimationFrame(() => resolve());
			});
		}

		destroy() {
			this.buttonElement?.removeEventListener('click', this.onButtonClick);
			this.setLoadingState(false);
			this.isLoading = false;
		}
	}

	customElements.define('tr-pagination', TrPagination);
}
